import React, { useState, useEffect } from "react";
import grey from "@material-ui/core/colors/grey";
import StopSharpIcon from "@material-ui/icons/StopSharp";
import PropTypes from "prop-types";
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import {
  withStyles,
  makeStyles,
  createStyles,
  useTheme,
} from "@material-ui/core/styles";
import clsx from "clsx";
import Box from "@material-ui/core/Box";
import {
  FormHelperText,
  Input,
  InputLabel,
  InputBase,
} from "@material-ui/core";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import FormLabel from "@material-ui/core/FormLabel";
import Checkbox from "@material-ui/core/Checkbox";
import {
  DatePicker,KeyboardDatePicker
} from '@material-ui/pickers';
import CalendarTodayIcon from '@material-ui/icons/CalendarToday';

const useStyles = makeStyles((theme) => ({
  justifyContentBetween: {
    justifyContent: "space-between!important",
  },
  alignItemsStretch: {
    alignItems: "stretch",
  },
  borderRight: {
    borderRight: "1px solid " + grey[400],
  },
  MuiButtonBaseRoot: {
    borderRadius: 4,
    padding: 0,
    paddingBottom: "2px",
    color: grey[400],
  },
  MuiSvgIconRoot: {
    color: "#ff4717",
    border: "2px solid " + grey[400],
    fontSize: "1.3rem",
    borderRadius: 3,
  },
  anchorTag: {
    textDecoration: "none",
    cursor: "pointer",
  },
}));
const BootstrapInput = withStyles((theme) => ({
  root: {
    "label + &": {
      marginTop: theme.spacing(2),
    },
  },

  input: {
    borderRadius: 4,
    position: "relative",
    backgroundColor: theme.palette.common.white,
    border: "1px solid #ced4da",
    fontSize: 16,
    width: "auto",
    padding: "10px 12px",
    height: "0.1876em",
    // marginLeft: '2.2em',
    transition: theme.transitions.create(["border-color", "box-shadow"]),
    // Use the system font instead of the default Roboto font.
    fontFamily: [
      "-apple-system",
      "BlinkMacSystemFont",
      '"Segoe UI"',
      "Roboto",
      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(","),
    "&:focus": {
      // boxShadow: `${fade(theme.palette.primary.main, 0.25)} 0 0 0 0.2rem`,
      borderColor: theme.palette.primary.main,
    },
  },
}))(InputBase);

const BootstrapDate = withStyles((theme) => ({
  root: {
    "label + &": {
      marginTop: theme.spacing(2),
    },
  },

  input: {
    borderRadius: 4,
    position: "relative",
    backgroundColor: theme.palette.common.white,
    border: "1px solid #ced4da",
    fontSize: 16,
    width: "100%",
    padding: "10px 12px",
    height: "0.1876em",
    // marginLeft: '2.2em',
    transition: theme.transitions.create(["border-color", "box-shadow"]),
    // Use the system font instead of the default Roboto font.
    fontFamily: [
      "-apple-system",
      "BlinkMacSystemFont",
      '"Segoe UI"',
      "Roboto",
      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(","),
    "&:focus": {
      // boxShadow: `${fade(theme.palette.primary.main, 0.25)} 0 0 0 0.2rem`,
      borderColor: theme.palette.primary.main,
    },
  },
}))(InputBase);
function Filters(props) {
  const classes = useStyles();
  const [filter, setFilter] = React.useState(true);
  const [selectedStartDate, handleStartChange] = useState(new Date());
  const [selectedEndDate, handleEndChange] = useState(new Date());
  const [selectedValue, setSelectedValue] = React.useState('critical');
  const handleChange = (event) => {
    setSelectedValue(event.target.value);
  };
  return (
    <div>
      <Box
        component="div"
        px={1}
        pt={1.2}
        pb={1}
        display="flex"
        className={clsx(
          classes.justifyContentBetween,
          classes.alignItemsStretch
        )}
      >
         <Box component="h2" m={0}  className="blcopy" fontWeight="500"  pl={2}>
          Filters:
        </Box>
        {/* <Box
          component="a"
          href="javascript:void(0)"
          color={grey}
          className={classes.anchorTag  + " hide-link"}
          onClick={() => {
            setFilter(!filter);
          }}
          fontSize="13px"
        >
          {filter ? "Hide Filter" : "Show Filter"}
        </Box> */}
      </Box>
      <Box
        component="div"
        px={1}
        pt={1}
        pb={2}
        display={filter ? "flex" : "none"}
        className={clsx(
          classes.justifyContentBetween,
          classes.alignItemsStretch
        )}
      >
      <Grid container spacing={3} className="reports-filter-row" >
        <Grid  className="reports-filter-col">
        <Box
          component="div"
          className="reports-filter"
          pl={2}
        >
          <Box
            component="div"
            display="flex"
            className={classes.justifyContentBetween}
            pb={3}
          ></Box>
          <Box
            component="div"
            display="flex"
            className="re-filter-input" 
            pb={1}
          >
            <Box component="label"  >
              Lab
            </Box>
            <Box component="div" className="re-filter-box">
              <BootstrapInput />
            </Box>
          </Box>
          <Box
            component="div"
            display="flex"
            className="re-filter-input" 
          >
            <Box component="label" >
              Vessel IMO
            </Box>
            <Box component="div" className="re-filter-box">
              <BootstrapInput />
            </Box>
          </Box>
        </Box>
        </Grid>
        <Grid className="reports-filter-col">
        <Box
          component="div"
          className={classes.borderRight}
        >
          <Box
            component="div"
            fontWeight="bold"
           
            display="flex"  className="blcopy"
          >
            Date
          </Box>
          <Box
            component="div"
            display="flex"
            className="re-filter-input" 
            py={1}
            
          >
            <Box component="label" >
              Sampled Date
            </Box>
            {/* <Box component="div">
              <BootstrapInput />
            </Box> */}
             <Box component="span" className=" date-input pad-right-1"   >
             
              <KeyboardDatePicker
              
          margin="normal"
          id="date-picker-dialog"
         // label="Date picker dialog"
          format="DD/MM/yyyy"
          value={selectedStartDate}
          onChange={handleStartChange}
          KeyboardButtonProps={{
            'aria-label': 'change date',
          }}
        />
             
            </Box>
            <Box component="span" className=" date-input" mr="2"  >
            <KeyboardDatePicker
          margin="normal"
          id="date-picker-dialog"
         // label="Date picker dialog"
          format="DD/MM/yyyy"
          value={selectedEndDate}
          onChange={handleEndChange}
          KeyboardButtonProps={{
            'aria-label': 'change date',
          }}
        />
             
            </Box>
            
          </Box>
          <Box
            component="div"
            display="flex"
            className="re-filter-input" 
          >
            <Box component="label"  >
              Reported Date
            </Box>
            <Box component="span" className="date-input pad-right-1 "   >
              
              <KeyboardDatePicker
          margin="normal"
          id="date-picker-dialog"
         // label="Date picker dialog"
          format="DD/MM/yyyy"
          value={selectedStartDate}
          onChange={handleStartChange}
          KeyboardButtonProps={{
            'aria-label': 'change date',
          }}
        />
             

              
              
            </Box>
            <Box component="span" className="date-input  "  >
            <KeyboardDatePicker
          margin="normal"
          id="date-picker-dialog"
         // label="Date picker dialog"
          format="DD/MM/yyyy"
          value={selectedEndDate}
          onChange={handleEndChange}
          KeyboardButtonProps={{
            'aria-label': 'change date',
          }}
        />
             
            </Box>

            
          </Box>
        </Box>
        </Grid>
        <Grid  className="reports-filter-col"> 
        <Box
          component="div"
          className={classes.borderRight}
        >
          <Box
            component="div"
            fontWeight="bold"
            
            display="flex"  className="blcopy"
          >
            Equipment
          </Box>
          <Box
            component="div"
            display="flex"
            className="re-filter-input" 
            py={1}
          >
            <Box component="label" >
              Equip Make{" "}
            </Box>
            <Box component="div" className="re-filter-box">
              <BootstrapInput />
            </Box>
          </Box>
          <Box
            component="div"
            display="flex"
            className="re-filter-input" 
          >
            <Box component="label" >
              Equip Model
            </Box>
            <Box component="div" className="re-filter-box">
              <BootstrapInput />
            </Box>
          </Box>
        </Box>
        </Grid>
        <Grid className="reports-filter-col">    
        <Box
          component="div"
          className={classes.borderRight}
        >
          <Box
            component="div"
            fontWeight="bold"
            
            display="flex"  className="blcopy"
          >
            LO
          </Box>
          <Box
            component="div"
            display="flex"
            className="re-filter-input" 
            py={1}
          >
            <Box component="label"  >
              LO Brand
            </Box>
            <Box component="div" className="re-filter-box">
              <BootstrapInput />
            </Box>
          </Box>
          <Box
            component="div"
            display="flex"
            className="re-filter-input" 
          >
            <Box component="label" >
              LO Grade
            </Box>
            <Box component="div" className="re-filter-box">
              <BootstrapInput />
            </Box>
          </Box>
        </Box>
        </Grid>
        <Grid  className="reports-filter-col"> 
        <Box component="div">
          <Box
            component="div"
            display="flex"
            className={classes.justifyContentBetween}
            alignItems="flex-end"
            height={1}
          >
            <Box component="div" width={1} display="block" className="report-status">
              <Box
                component="div"
                fontWeight="bold"
                
                display="flex"  className="blcopy"
                pb={1}
              >
                Report Status
              </Box>
              <Box
                component="div"
                display="block"
                className={classes.justifyContentBetween + " reports-radio"}
              >
                <Box component="div" alignItems="center" display="flex">
                 
                 
               <Radio value= 'critical' checked={selectedValue === 'critical'}
               onChange={handleChange}
               />
                  <Box component="span" pl={0}  >
                    Critical
                  </Box>
                </Box>
                <Box component="div" alignItems="center" display="flex">
                <Radio value= 'warning' checked={selectedValue === 'warning'}
                onChange={handleChange}
                />
                  <Box component="span" pl={1}  >
                    {"Warning"}
                  </Box>
                </Box>
                <Box component="div" alignItems="center" display="flex">
                <Radio value= 'satisfactory' checked={selectedValue === 'satisfactory'}
                onChange={handleChange}
                />
                  <Box component="span" pl={1} >
                    {"Satisfactory"}
                  </Box>
                </Box>
                <Box component="div" alignItems="center" display="flex">
                <Radio value= 'other' checked={selectedValue === 'other'}
                onChange={handleChange}
                />
                  <Box component="span" pl={1}  >
                    {"other"}
                  </Box>
                </Box>
                <Box component="div" alignItems="center" display="flex">
                <Radio value= 'all' checked={selectedValue === 'all'}
                onChange={handleChange}
                />
                  <Box component="span" pl={1}  >
                    {"All"}
                  </Box>
                </Box>

              </Box>
            </Box>
          </Box>
        </Box>
        </Grid>
        </Grid>
      </Box>
    </div>
  );
}

Filters.propTypes = {};

export default Filters;
